var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDangerIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C7.76142 10.5 10 8.26142 10 5.5C10 2.73858 7.76142 0.5 5 0.5C2.23858 0.5 0 2.73858 0 5.5C0 8.26142 2.23858 10.5 5 10.5Z",
    fill: "#BF2315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5C4.81893 6.49999 4.64489 6.42992 4.51433 6.30446C4.38377 6.179 4.30682 6.00788 4.29961 5.82695L4.20723 3.49414C4.20352 3.39985 4.21889 3.30577 4.25242 3.21756C4.28594 3.12935 4.33694 3.04882 4.40234 2.98079C4.46774 2.91276 4.54621 2.85864 4.63303 2.82166C4.71985 2.78469 4.81325 2.76563 4.90762 2.76562H5.09238C5.18675 2.76563 5.28015 2.78469 5.36697 2.82166C5.45379 2.85864 5.53226 2.91276 5.59766 2.98079C5.66306 3.04882 5.71406 3.12935 5.74758 3.21756C5.78111 3.30577 5.79648 3.39985 5.79277 3.49414L5.70039 5.82695C5.69318 6.00788 5.61623 6.179 5.48567 6.30446C5.35511 6.42992 5.18107 6.49999 5 6.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6998 7.53457C5.6998 7.14808 5.38649 6.83477 5 6.83477C4.61351 6.83477 4.3002 7.14808 4.3002 7.53457C4.3002 7.92106 4.61351 8.23438 5 8.23438C5.38649 8.23438 5.6998 7.92106 5.6998 7.53457Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIconRed);
export default __webpack_public_path__ + "static/media/dangerIconRed.85bbb6d5c7646dcb127d8b3be20c9756.svg";
export { ForwardRef as ReactComponent };